<template>
  <div class="card">
    <!-- Header -->
    <div class="card-header">
      <div class="card-title">
        Biểu đồ tình hình kết quả dạy &amp; học
      </div>

      <div class="controls">
        <div class="year-select-custom">
          <el-select v-model="year" placeholder="Select" style="width: 100px;border-radius: 50px" size="mini"
                     @change="getTeachingReport">
            <el-option
                v-for="item in years"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="year-select-custom" v-if="range === '12w'">
          <el-select v-model="quarter" placeholder="Select" style="width: 100px;border-radius: 50px" size="mini"
                     @change="getTeachingReport">
            <el-option
                v-for="item in quarters"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="range-pill-group">
          <button
              class="range-pill"
              :class="{ active: range === '12w' }"
              @click="setRange('12w')"
          >
            Quarter
          </button>
          <button
              class="range-pill"
              :class="{ active: range === '12m' }"
              @click="setRange('12m')"
          >
            Year
          </button>
        </div>
      </div>
    </div>

    <!-- Chart -->
    <div class="chart-wrapper" style="position: relative">
      <div v-if="chartLoading" :class="series.length >  0 ? 'bg-gray-2' : 'bg-white-2'" style="
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  ">
        <i class="el-icon-loading" style="font-size: 30px; color:  black;"></i>
      </div>
      <apexchart
          ref="chart"
          v-if="series.length > 0"
          type="line"
          height="360"
          :options="chartOptions"
          :series="series"
      />
      <div v-else style="height: 360px;"></div>
    </div>
    <!-- Custom legend -->
  </div>
</template>

<script>
import moment from 'moment-timezone';
import {GET_TEACHING_REPORT} from "../../../../../core/services/store/report-error/reportError.module";

export default {
  name: 'TeachingLearningChart',
  props: {
    teacherFilter: {
      type: Object
    }
  },
  data() {
    return {
      year: 2024,
      years: [],
      quarter: 1,
      quarters: [{value: 1, label: 'Quý 1'}, {value: 2, label: 'Quý 2'}, {value: 3, label: 'Quý 3'}, {
        value: 4,
        label: 'Quý 4'
      }],
      range: '12m',
      monthList: [
        'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
        'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
      ],
      weekList: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10', 'W11', 'W12', 'W13'],
      series: [],
      filter: {
        startDate: '',
        endDate: '',
      },
      ApiTimeOut: null,
      chartLoading: false,
      chartKey: 0,
      isHiddenApplied: false
    }
  },
  async mounted() {
    try {
      await this.getCurrentQuarter()
      await this.getListYear()
      await this.getTeachingReport()
    } catch (e) {

    }

  },

  computed: {
    categories() {
      return this.range === '12m' ? this.monthList : this.weekList
    },
    chartOptions() {
      const vm = this
      return {
        chart: {
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: [],
            }
          },
          zoom: {enabled: true},
          stacked: false,
          events: {
            updated: function (chartContext, config) {
                const seriesToHide = [
                  "Tỉ lệ làm BTVN",
                  "Tỉ lệ đạt năng lực",
                  "Tỉ lệ pass Midterm",
                  "Tỉ lệ pass Final (Thi lại)"
                ]
                if(vm.isHiddenApplied){
                  seriesToHide.forEach(name => {
                    if (chartContext.w.globals.seriesNames.includes(name)) {
                      chartContext.hideSeries(name)
                    }
                  })
                  vm.isHiddenApplied = false
                }

            }
          },
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro Text','Segoe UI', sans-serif"
        },
        grid: {
          borderColor: '#e5e7eb',
          strokeDashArray: 5
        },
        markers: {
          size: [0, 4, 4, 4, 4, 4, 4, 4],
          strokeWidth: 0
        },
        dataLabels: {
          enabled: false
        },

        stroke: {
          curve: 'straight',
          width: [0, 2, 2, 2, 2, 2, 2, 2],
          dashArray: [0, 0, 0, 0, 0, 0, 0, 0]
        },
        colors: ['#4A3AFF', '#FF383C', '#4A4A4A', '#FFCC00', '#AC7F5E', '#E900FE', '#00A806', '#1BC5BD'],
        xaxis: {
          categories: this.categories,
          labels: {
            style: {
              colors: '#9ca3af',
              fontSize: '11px'
            }
          },
          axisBorder: {show: false},
          axisTicks: {show: false}
        },
        yaxis: [
          {
            labels: {
              style: {
                colors: '#9ca3af',
                fontSize: '11px'
              },
              formatter: (value) => value.toFixed(0),
            },
            min: 0,
            max: undefined,
            tickAmount: 4
          },
          {
            opposite: true,
            tickAmount: 5,
            labels: {
              style: {
                colors: '#9ca3af',
                fontSize: '11px'
              },
              formatter: (value) => `${value}%`
            }
          },
        ],
        legend: {
          show: true // legend custom bên dưới
        },
        tooltip: {
          enabled: true,   // bật tooltip
          shared: false,   // ❗ không dùng tooltip chung cho tất cả series
          intersect: false, // ❗ chỉ hiện khi trỏ CHÍNH XÁC vào điểm (bar/marker)
          y: {
            formatter: (value, {seriesIndex, w}) => {
              const name = w?.globals?.seriesNames[seriesIndex] || ''

              if (name.startsWith('Tỉ lệ')) {
                return `${value} %`
              }

              // các series khác giữ nguyên
              return value
            }
          }
        }
      }
    }

  },

  methods: {
    async getTeachingReport() {
      try {
        this.chartLoading = true
        this.isHiddenApplied = true
        clearTimeout(this.ApiTimeOut)
        const {
          start,
          end
        } = this.range === '12m' ? this.getYearRange(this.year) : this.getQuarterRange(this.year, this.quarter)
        let payload = {
          group_teacher_ids: this.teacherFilter?.groupLecturer,
          teacher_ids: this.teacherFilter?.lecturer,
          classroom_ids: this.teacherFilter?.classroomId,
          center_ids: this.teacherFilter?.centerId,
          course_ids: this.teacherFilter?.courseId,
          from_date: start,
          to_date: end,
          view_mode: this.range === '12m' ? 'year' : 'quarter'
        }
        this.ApiTimeOut = setTimeout(async () => {
          try {
            const res = await this.$store.dispatch(GET_TEACHING_REPORT, payload)
            const newSeries = res?.data?.series.map(item => ({
              name: item.display_name,
              type: item.type === 'bar' ? 'column' : item.type,
              data: item.values,
              yAxisIndex: item.y_axis === 'right' ? 1 : 0
            }))

            this.series = newSeries

            this.$nextTick(() => {
              this.$refs.chart.updateSeries(newSeries)
            })
          } catch (e) {

          } finally {
            this.chartLoading = false
          }

        }, 700)

      } catch (e) {

      }
    },
    async setRange(range) {
      this.range = range
      await this.getTeachingReport()
    },
    getCurrentQuarter() {
      this.quarter = Math.floor(moment().month() / 3) + 1;
    },
    getListYear() {
      this.year = moment().year();
      for (let y = this.year; y >= 2020; y--) {
        this.years.push(y);
      }
    },
    getQuarterRange(year, quarter) {
      const start = moment(`${year}-01-01`)
          .quarter(quarter)
          .startOf('quarter')
          .format("YYYY-MM-DD");

      const end = moment(`${year}-01-01`)
          .quarter(quarter)
          .endOf('quarter')
          .format("YYYY-MM-DD");

      return {start, end};
    },
    getYearRange(year) {
      return {
        start: `${year}-01-01`,
        end: `${year}-12-31`
      };
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.07);
  padding: 24px 28px 18px;
  max-width: 920px;
  width: 100%;
  color: #111827;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
}

.controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.year-select {
  position: relative;
}

.year-select select {
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  padding: 6px 34px 6px 14px;
  font-size: 13px;
  outline: none;
  background: #f9fafb;
  appearance: none;
  cursor: pointer;
}

.year-select::after {
  content: "▾";
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: #6b7280;
  pointer-events: none;
}

.range-pill-group {
  display: inline-flex;
  border-radius: 999px;
  background: #f3f4ff;
  padding: 3px;
}

.range-pill {
  border: none;
  background: transparent;
  padding: 5px 12px;
  font-size: 12px;
  border-radius: 999px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 72px;
  text-align: center;
}

.range-pill.active {
  background: #4f46e5;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.4);
}

.chart-wrapper {
  width: 100%;
  margin-top: 10px;
}

/* Legend */
.legend-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 18px;
  margin-top: 18px;
  font-size: 11.5px;
}

.legend-item {
  padding: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 2px solid #D2D2D2;
  border-radius: 6px;
  cursor: pointer;
}

.legend-item-active {
  border: 2px solid #0066FF;
  background-color: #EFF5FF;
}

.legend-dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
}

.legend-dot.border {
  border: 2px solid currentColor;
  background: transparent;
}

.legend-label {
  color: #4b5563;
  white-space: nowrap;
}

.bg-gray-2 {
  background-color: rgba(128, 128, 128, 0.28);
}

.bg-white-2 {
  background-color: white;
}

@media (max-width: 640px) {
  .card {
    padding: 18px 16px 12px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .controls {
    width: 100%;
    justify-content: space-between;
  }

  .legend-wrapper {
    flex-direction: column;
  }

}
</style>
